var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface62917183"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.470589%,22.352941%,60.000002%)",
      fillOpacity: 1
    },
    d: "M 42 37 C 42 39.761719 39.761719 42 37 42 L 11 42 C 8.238281 42 6 39.761719 6 37 L 6 11 C 6 8.238281 8.238281 6 11 6 L 37 6 C 39.761719 6 42 8.238281 42 11 Z M 42 37 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.03125 25.601562 C 32.378906 24.699219 31.441406 24.078125 30.230469 23.75 C 30.230469 23.75 31.25 23.378906 32.171875 22 C 32.71875 21.121094 33 20.058594 33 18.820312 C 33 16.671875 32.21875 15.019531 30.660156 13.890625 C 29.101562 12.761719 27.339844 12 24.351562 12 L 15 12 L 15 36 L 25.429688 36 C 28.261719 35.980469 30.390625 35.371094 31.839844 34.199219 C 33.28125 33.011719 34 31.25 34 28.898438 C 34 27.601562 33.679688 26.5 33.03125 25.601562 Z M 21 16 C 21 16 25.171875 16 25.25 16 C 26.769531 16 28 17.230469 28 18.75 C 28 20.269531 26.769531 21.5 25.25 21.5 C 25.171875 21.5 21 21.5 21 21.5 Z M 26 32 L 21 32 L 21 26 L 26 26 C 27.660156 26 29 27.339844 29 29 C 29 30.660156 27.660156 32 26 32 Z M 26 32 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.cebb9d226e7f0fa1a67774886b02f31c.svg";
export { ForwardRef as ReactComponent };